export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/collage_pattern.d5e5ecc.svg";